module.exports = __webpack_public_path__ + "static/media/LockedBy.4d5a1303.png";